<template>
  <div class="guides">
    <header class="site-header">
      <div class="site-header-inner">
        <router-link class="site-logo" to="/" aria-label="Forever-X home"><span class="brand-mark">FOREVER<span>-X</span></span></router-link>
        <nav class="site-nav" aria-label="Main">
          <router-link to="/guides" class="site-nav-link active">Guides</router-link>
        </nav>
        <a class="btn btn-primary" href="/who" @click.prevent="createMemorial">Create a Memorial</a>
      </div>
    </header>

    <main>
      <slot />
    </main>

    <footer class="site-footer">
      <div class="wrap footer-inner">
        <div class="footer-brand">
          <div class="brand-mark">FOREVER<span>-X</span></div>
          <div class="footer-tagline">Ad-free. No stock templates. Built for remembering people the way they actually lived.</div>
        </div>
        <nav class="footer-links" aria-label="Footer">
          <router-link to="/guides">Guides</router-link>
          <router-link to="/privacy-policy">Privacy Policy</router-link>
          <router-link to="/terms-and-conditions">Terms &amp; Conditions</router-link>
        </nav>
      </div>
      <div class="wrap footer-copy">© {{ year }} Forever-X. forever-x.com</div>
    </footer>

    <div class="toast" :class="{ show: toast.show }" role="status" aria-live="polite"><span>{{ toast.text }}</span></div>
  </div>
</template>

<script setup>
import { useStartMemorial } from '../../composables/useStartMemorial'
import { useGuideToast } from './useGuideToast'
import '../../styles/guides.scss'

const { createMemorial } = useStartMemorial()
const { toast } = useGuideToast()
const year = new Date().getFullYear()
</script>
